import React from 'react';
import { Link } from 'react-router-dom';

export default function AnnouncementSection() {
  return (
    <section className="w-full bg-blue-50 py-8 md:py-12">
      <div className="container mx-auto px-4 md:px-8">
        <Link
          to="/proceso-admision"
          className="block w-full max-w-6xl mx-auto rounded-xl overflow-hidden shadow-lg border border-blue-100 transition-transform duration-300 hover:scale-[1.01] focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2"
          aria-label="Matrículas abiertas — revisa el proceso de admisión"
        >
          <img
            src="/images/matriculas-abiertas.png"
            alt="¡Matrículas abiertas! Escuela de Lenguaje Arcoíris. Atendemos a niños y niñas de 3 a 5 años. Es gratuito, financiado por el Ministerio de Educación. Contacto: +56 9 5739 6243 · elarcoiris_va · Sgto. Candelaria 290, Villa Alemana."
            className="w-full h-auto block"
            width={2828}
            height={1088}
            loading="lazy"
            decoding="async"
          />
        </Link>
      </div>
    </section>
  );
}
